import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header, PageWrapper, Section } from '@everfi/reactifi';
import everfi_homescreen_hero from '../images/everfi-homescreen-hero.jpg';
import { Center } from '@chakra-ui/layout';

const LandingPage = () => {
  const { t } = useTranslation();
  return (
    <PageWrapper>
      <Header title={t('Admin - Dashboard')} />
      <Section>
        <Center>
          <h3>Welcome to Foundry Internal Tools</h3>
        </Center>
        <Center>
          <img src={everfi_homescreen_hero} alt={'Welcome'} />
        </Center>
      </Section>
    </PageWrapper>
  );
};

export default LandingPage;
